import type { FC } from 'react';
import type { LegalEntity } from '@pflegenavi/shared/api';
import { KycIdvDialog } from '@pflegenavi/web-components';
import {
  useCreateLegalEntityIdvSession,
  useGetLegalEntityIdvSession,
  useRetryLegalEntityIdvPsc,
} from '@pflegenavi/frontend/api-nursing-home';

interface LegalEntityKycIdvDialogProps {
  legalEntity: LegalEntity;
  open: boolean;
  onClose: () => void;
  returnUrl: string;
}

export const LegalEntityKycIdvDialog: FC<LegalEntityKycIdvDialogProps> = ({
  legalEntity,
  open,
  onClose,
  returnUrl,
}) => {
  const sessionStatus = legalEntity.mangopay_idv_session_status;
  const { data: session, isPending: sessionLoading } =
    useGetLegalEntityIdvSession(legalEntity.id, {
      enabled: open && sessionStatus !== null,
    });
  const { mutateAsync: createIdvSession } = useCreateLegalEntityIdvSession(
    legalEntity.id
  );
  const { mutateAsync: retryIdvPsc } = useRetryLegalEntityIdvPsc(
    legalEntity.id
  );

  return (
    <KycIdvDialog
      open={open}
      onClose={onClose}
      subtitle={legalEntity.base_data.company}
      subject="legal-entity"
      kycVerified={legalEntity.mangopay_kyc_verified}
      renewalDeadline={legalEntity.kyc_renewal_deadline}
      lastKycDate={legalEntity.last_kyc_date}
      sessionStatus={sessionStatus}
      session={session}
      sessionLoading={sessionLoading}
      returnUrl={returnUrl}
      onStartSession={createIdvSession}
      onRetryPsc={retryIdvPsc}
    />
  );
};
